import script from "./SearchHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchHeader.vue?vue&type=script&lang=ts&setup=true"

import "./SearchHeader.vue?vue&type=style&index=0&id=3f0fc163&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0fc163"]])

export default __exports__